import { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import LoadingContainer from 'components/common/LoadingContainer';
import ConfirmationModal from 'components/common/modals/ConfirmationModal';
import { useBeneficiaryContext } from 'context/beneficiaryContext';
import { useCaseStudies, useDeleteCaseStudy } from 'hooks/useCaseStudies';
import CaseStudyCard from 'components/case-studies/CaseStudyCard';
import CaseStudyFormModal from 'components/case-studies/CaseStudyFormModal';

// Beneficiary profile > Case Studies tab
const BeneficiaryCaseStudies = () => {
  const { id } = useParams();
  const { beneficiary } = useBeneficiaryContext();
  const { caseStudies, isLoading } = useCaseStudies(id);
  const { deleteCaseStudy, isDeleting } = useDeleteCaseStudy();
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [toDelete, setToDelete] = useState(null);

  if (isLoading) return <LoadingContainer />;

  const fixedOrphan = beneficiary
    ? {
        id: beneficiary.id,
        name: `${beneficiary.first_name} ${beneficiary.last_name}`,
        branch_id: beneficiary.branch_id
      }
    : null;

  return (
    <>
      <Card className="mb-3">
        <Card.Header>
          <Flex justifyContent="between" alignItems="center">
            <h5 className="mb-0">Case Studies ({caseStudies.length})</h5>
            <IconButton
              icon="plus"
              variant="falcon-primary"
              size="sm"
              onClick={() => {
                setEditing(null);
                setShowForm(true);
              }}
            >
              Add Case Study
            </IconButton>
          </Flex>
        </Card.Header>
        {caseStudies.length === 0 && (
          <Card.Body className="text-center text-600 py-4">
            No case studies recorded for this child yet.
          </Card.Body>
        )}
      </Card>

      {caseStudies.map(cs => (
        <CaseStudyCard
          key={cs.id}
          caseStudy={cs}
          showChild={false}
          onEdit={c => {
            setEditing(c);
            setShowForm(true);
          }}
          onDelete={setToDelete}
        />
      ))}

      {showForm && (
        <CaseStudyFormModal
          show={showForm}
          onHide={() => setShowForm(false)}
          caseStudy={editing}
          fixedOrphan={fixedOrphan}
        />
      )}
      <ConfirmationModal
        show={!!toDelete}
        onHide={() => setToDelete(null)}
        loading={isDeleting}
        title="Delete case study"
        confirmText="Delete"
        handleConfirm={() =>
          deleteCaseStudy(toDelete.id, { onSuccess: () => setToDelete(null) })
        }
        body={
          toDelete ? `Delete "${toDelete.title}"? This cannot be undone.` : ''
        }
      />
    </>
  );
};

export default BeneficiaryCaseStudies;
